import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';

const AnalisesSidebar = ({ onOptionChange }) => {
    const items = [
        {
            label: 'Analise por Clientes',
            icon: 'pi pi-users',
            command: () => onOptionChange('analiseClientes')
        },
        {
            label: 'Analise de Fornecedores',
            icon: 'pi pi-briefcase',
            command: () => onOptionChange('analiseFornecedores')
        }
    ];

    return (
        <div className="p-3">
            <PanelMenu model={items} style={{ width: '100%' }} />
        </div>
    );
};

export default AnalisesSidebar;
